<template>
  <option :value="codigo">{{ nome }}</option>
</template>

<script>

export default {

  props: ["nome", "codigo"],
  data() {
    return {};
  },
  methods: {
  },
  created() {
  },
};
</script>

<style></style>
